<kl-grid
  [columns]="[
    {
      header: 'status' | translate,
      binding: 'status',
      translate: true,
      visible: true
    },
    { header: 'code' | translate, binding: 'code', visible: true },
    { header: 'description' | translate, binding: 'description', visible: true }
  ]"
  [filterable]="true"
  [deferResizing]="false"
  [tabId]="tabId || modalId"
  [mode]="mode ? mode : 'TAB'"
  [filterSelectItems]="filterSelectItems"
  [service]="{
    service: 'sector',
    name: 'sector',
    form: 'SECTOR',
    showButton: true,
    showDropDownButton: true
  }"
></kl-grid>
